"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorTileFeature = void 0;
const Point = require("@mapbox/point-geometry");
class VectorTileFeature {
    constructor(feature) {
        this.properties = {};
        this.type = 0;
        this.properties = feature.properties;
        this.extent = feature.extent;
        this._raw = feature;
        if (feature.id !== null) {
            this.id = Number(feature.id);
        }
    }
    loadGeometry() {
        // TODO: optimize to avoid needing this deep copy 
        const newGeometry = [];
        const oldGeometry = this._raw.loadGeometry();
        for (let i = 0; i < oldGeometry.length; i++) {
            newGeometry[i] = [];
            for (let j = 0; j < oldGeometry[i].length; j++) {
                newGeometry[i][j] = new Point(oldGeometry[i][j].x, oldGeometry[i][j].y);
            }
        }
        return newGeometry;
    }
    toGeoJSON(x, y, z) {
        return this._raw.toGeoJSON(x, y, z);
    }
}
exports.VectorTileFeature = VectorTileFeature;
//# sourceMappingURL=VectorTileFeature.js.map